import { Button, Flex, Link, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import { Color } from 'src/theme/color';

export const Agreement = ({
	isOpen,
	onClose,
	handleBuy,
}: {
	isOpen: boolean;
	onClose: () => any;
	handleBuy: () => void;
}) => {
	const handleAgreement = () => {
		localStorage.setItem('termsAgreed', 'true');
		handleBuy();
		onClose();
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
		>
			<ModalOverlay />
			<ModalContent
				background={Color.BACKGROUND_LIGHT}
				border={`1px solid ${Color.ACTION}`}
				padding="64px"
				width="60vw !important"
				maxWidth="auto !important"
				borderRadius="16px"
			>
				<ModalHeader>
					<Text
						fontWeight="bolder"
						color="action"
						fontSize="bigger"
					>
						Important
					</Text>
				</ModalHeader>
				<ModalBody
					display="flex"
					flexDirection="column"
					gridGap="16px"
				>
					<Text>
						By clicking the "I agree" button below or further using our services, you hereby agree to and
						accept the following terms and conditions governing your use of the GameContract.io services.
					</Text>
					<Text>
						You also acknowledge that transferring ERC-20 Cartridge between addresses can be subject of
						charges, commissions, and network fees.
					</Text>
					<Text>
						Details regarding commission and fees are described in section 8 of{' '}
						<Link
							color="action"
							href="https://cdn.hashup.it/gx-terms.pdf"
							target="_blank"
						>
							Terms and Conditions
						</Link>
						.
					</Text>
					<Flex paddingTop="16px">
						<Button onClick={handleAgreement}>I agree</Button>
					</Flex>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};
